import React, { useEffect, Suspense } from 'react';
import CenteredSpinner from '../components/Loaders/CenteredSpinner';

type DefaultLayoutProps = {
  layout: {
    layoutType: string;
    leftSideBarTheme: string;
    leftSideBarType: string;
    showRightSidebar: boolean;
  };
  children?: React.ReactNode;
};

const DefaultLayout = (props: DefaultLayoutProps) => {
  useEffect(() => {
    if (document.body) document.body.classList.add('authentication-bg');

    return () => {
      if (document.body) document.body.classList.remove('authentication-bg');
    };
  }, []);

  const children = props['children'] || null;
  return (
    <>
      <Suspense fallback={<CenteredSpinner color="primary" />}>{children}</Suspense>
    </>
  );
};
export default DefaultLayout;
